import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";
import { makeStore } from "./store/store";
import { AuthProvider } from "./auth/AuthProvider";
import { App } from "./App";
import "./store/api"; // registers all injectEndpoints side effects
import "./index.css";

const store = makeStore();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          {/* One ToastContainer for the whole app — doh_web_frontend mounted it per-page across 8 files. */}
          <ToastContainer position="top-right" autoClose={4000} />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
